import { FC } from 'react';
import style from './confidence-breakdown.module.scss';
import type { ConfidenceFactor } from 'pages/documents/structuring/types';

interface Props {
  factors: ConfidenceFactor[];
}

export const DEFAULT_FACTORS: Omit<ConfidenceFactor, 'scored' | 'note'>[] = [
  { factor: 'Name Similarity', weight: 0.45 },
  { factor: 'Entity Type Alignment', weight: 0.1 },
  { factor: 'Geographic & Citation Context', weight: 0.15 },
  { factor: 'Legal Description Overlap', weight: 0.15 },
  { factor: 'Address Similarity', weight: 0.1 },
  { factor: 'Cross-Party Context', weight: 0.05 },
];

const formatPercent = (n: number) => `${Math.round(n * 100)}%`;

export const ConfidenceBreakdown: FC<Props> = ({ factors }) => (
  <table className={style.table}>
    <thead>
      <tr>
        <th>Factor</th>
        <th>Weight</th>
        <th>Score</th>
      </tr>
    </thead>
    <tbody>
      {factors.map((f) => (
        <tr key={f.factor}>
          <td>{f.factor}</td>
          <td>{formatPercent(f.weight)}</td>
          <td>{f.scored !== null ? formatPercent(f.scored) : '—'}</td>
        </tr>
      ))}
    </tbody>
  </table>
);
